'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxRouter = require('redux-router');

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBrowserContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    mapView: state.events.mapView
  };
}, { push: _reduxRouter.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(EventBrowserContainer, _Component);

  function EventBrowserContainer() {
    (0, _classCallCheck3.default)(this, EventBrowserContainer);
    return (0, _possibleConstructorReturn3.default)(this, (EventBrowserContainer.__proto__ || (0, _getPrototypeOf2.default)(EventBrowserContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(EventBrowserContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.EventBrowser, this.props);
    }
  }]);
  return EventBrowserContainer;
}(_react.Component), _class2.propTypes = {
  mapView: _react.PropTypes.bool,
  title: _react.PropTypes.string
}, _temp)) || _class);
exports.default = EventBrowserContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/EventBrowserContainer.js
// module id = 1177
// module chunks = 0